import React from "react"
import Header from "../../common-components/Header/Header"
import PortfolioContext from "../../common-components/SectionComponents/PortfolioContext"
import CosmosContext from "../../common-components/SectionComponents/CosmosContext"
import MenuLink from "../../common-components/Navigation/MenuLink"
import MenuPage from "../menu-page/MenuPage"
import { scroll } from "../../utils/locomotiveScroll"

function CosmosPage() {
  const [menuOpen, setMenuOpen] = React.useState(false)
  const [isMobile, setisMobile] = React.useState(null)

  const changeMobile = () => {
    window.matchMedia("(max-width: 37.5em)").matches
      ? setisMobile(true)
      : setisMobile(false)
  }

  React.useEffect(() => {
    window.scroll(0, 0)
    scroll()
    changeMobile()
    window.addEventListener("resize", changeMobile)
    return () => window.removeEventListener("resize", changeMobile)
  }, [])

  return (
    <>
      {isMobile ? (
        <>
          <Header />
          {!menuOpen && (
            <>
              <CosmosContext />
              <PortfolioContext />
            </>
          )}
          <MenuPage setMenuOpen={setMenuOpen} menuOpen={menuOpen} />
          <MenuLink setMenuOpen={setMenuOpen} menuOpen={menuOpen} />
        </>
      ) : (
        <>
          <Header />
          <CosmosContext />
          <PortfolioContext />
          <MenuPage setMenuOpen={setMenuOpen} menuOpen={menuOpen} />
          <MenuLink setMenuOpen={setMenuOpen} menuOpen={menuOpen} />
        </>
      )}
    </>
  )
}

export default CosmosPage
